import { render, staticRenderFns } from "./EducationalGroupForm.vue?vue&type=template&id=c5909b3e&"
import script from "./EducationalGroupForm.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports